import React from 'react';
import { graphql, useFragment } from 'react-relay';

import {
  PromotionDescriptionList_promotion$data,
  PromotionDescriptionList_promotion$key,
} from '../../../relay/__generated__/PromotionDescriptionList_promotion.graphql';
import DateText from '../../core/DateText';
import DescriptionList, { DescriptionListProps } from '../../core/DescriptionList';
import SQLEditor from '../../core/SQLEditor';
import Text from '../../core/Text';
import UserAvatarText from '../../user/UserAvatarText';
import PromotionRepeatText from '../PromotionRepeatText';
import PromotionStatusLabel from '../PromotionStatusLabel';

const PromotionDescriptionList_promotion = graphql`
  fragment PromotionDescriptionList_promotion on Promotion {
    id

    title
    priority

    page {
      __typename
    }

    startAt
    endAt
    ...PromotionRepeatText_promotion
    query

    createdBy {
      id
      ...UserAvatarText_user
    }
    created
    ...PromotionStatusLabel_promotion
  }
`;

type Props = {
  promotion: PromotionDescriptionList_promotion$key;
  type?: 'default' | 'activity';
} & Omit<DescriptionListProps<PromotionDescriptionList_promotion$data>, 'item' | 'itemDescriptions' | 'picks'>;
const PromotionDescriptionList = ({ promotion: promotionReference, type = 'default', ...props }: Props) => {
  const promotion = useFragment(PromotionDescriptionList_promotion, promotionReference);

  return (
    <DescriptionList
      item={promotion}
      itemDescriptions={{
        title: {
          title: '프로모션명',
          renderValue: ({ title }) => <Text fontSize={1}>{title}</Text>,
        },
        priority: {
          title: '우선순위',
          renderValue: ({ priority }) => <Text fontSize={1}>{priority}</Text>,
        },
        page: {
          title: '프로모션 페이지',
          renderValue: ({ page }) => <Text fontSize={1}>{page ? '있음' : '없음'}</Text>,
        },
        startAt: {
          title: '시작일',
          renderValue: ({ startAt }) => <DateText fontSize={1}>{startAt}</DateText>,
        },
        endAt: {
          title: '종료일',
          renderValue: ({ endAt }) => <DateText fontSize={1}>{endAt}</DateText>,
        },
        repeat: {
          title: '주기',
          renderValue: (promotion) => <PromotionRepeatText fontSize={1} promotion={promotion} />,
        },
        sql: {
          title: 'SQL',
          renderValue: ({ query }) => <SQLEditor readOnly value={query ?? ''} height={200} />,
        },

        createdBy: {
          title: '제작자',
          renderValue: ({ createdBy }) => <UserAvatarText user={createdBy} />,
        },
        created: {
          title: '제작일',
          renderValue: ({ created }) => <DateText fontSize={1}>{created}</DateText>,
        },
        status: {
          title: '상태',
          renderValue: (promotion) => <PromotionStatusLabel promotion={promotion} />,
        },
      }}
      picks={
        type === 'default'
          ? ['title', 'priority', 'page', 'startAt', 'endAt', 'repeat', 'sql']
          : type === 'activity'
          ? ['createdBy', 'created', 'status']
          : []
      }
      {...props}
    />
  );
};

export default PromotionDescriptionList;
